export const userCoinKeys = {
  coinCounts: (userHash) => ['user', 'coin_counts', userHash],
}

export const userPointKeys = {
  pointCounts: (userHash) => ['user', 'point_counts', userHash],
  availablePoints: (userHash) => ['user', 'available_points', userHash],
}

export const pointBackMeasureKeys = {
  pointBackMeasure: ['pointBackMeasure'],
}

export const cartItemsKeys = {
  cartItemsLoggedIn: (userHash) => ['user', 'cartItems', 'loggedIn', userHash],
  cartItemsNotLoggedIn: () => ['cartItems', 'notLoggedIn'],
}

export const cardInfoKeys = {
  cardInfo: ['cardInfo'],
}

export const bookDetailsKeys = {
  bookDetails: (bookId) => ['bookDetails', bookId],
}

export const purchaseHistoriesKeys = {
  purchaseHistories: (userHash) => ['user', 'purchaseHistories', userHash],
}

export const announcementsKeys = {
  announcements: ['announcements'],
  announcementDetail: (announcementId) => ['announcementDetail', announcementId],
}

export const userAccountKeys = {
  accountInfo: (userHash) => ['user', 'account_info', userHash],
}

export const userCheckPurchasedBookKeys = {
  check: (userHash, contentIds) => ['user', 'checkPurchasedBooks', userHash, contentIds],
}

export const volumesKeys = {
  volumes: (bookTitleId) => ['volumes', bookTitleId],
}

export const userCouponKeys = {
  coupons: (userHash) => ['user', 'coupons', userHash],
}

export const newBooksKeys = {
  all: ['newBooks'],
  filtered: (safeSearch, genreName, page, perPage) => [...newBooksKeys.all, safeSearch, genreName, page, perPage],
}

export const rankingKeys = {
  all: ['ranking'],
  filtered: (safeSearch, rankingType, page, fetchType) => [...rankingKeys.all, safeSearch, rankingType, page, fetchType],
}

export const searchKeys = {
  search: (type, searchTerm, page, safeSearch, options) => ['search', type, searchTerm, page, safeSearch, options],
}

export const topFeaturesKeys = {
  all: ['topFeatures'],
  filtered: (safeSearch, genreName, page) => [...topFeaturesKeys.all, safeSearch, genreName, page],
}

export const topNewBooksKeys = {
  all: ['topNewBooks'],
  filtered: (safeSearch, genreName) => [...topNewBooksKeys.all, safeSearch, genreName],
}

export const topRankingsKeys = {
  all: ['topRankings'],
  filtered: (safeSearch, genreName) => [...topRankingsKeys.all, safeSearch, genreName],
}

export const topBulkPurchaseTitlesKeys = {
  all: ['topBulkPurchaseTitles'],
  filtered: (safeSearch) => [...topBulkPurchaseTitlesKeys.all, safeSearch],
}

export const topFreeFeaturesKeys = {
  all: ['topFreeFeatures'],
  filtered: (safeSearch, device) => [...topFreeFeaturesKeys.all, safeSearch, device],
}

export const freeTitlesKeys = {
  free_titles: (genreTabName, page, fetchType) => ['freeTitles', genreTabName, page, fetchType],
}
